export const align_justify = () => (
  <path
    d="M21 10H3m18-4H3m18 8H3m18 4H3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
